import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/storefront/frontend/components/HOC/chunk-error-handler/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/storefront/frontend/components/HOC/hash-scroll-handler/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/storefront/frontend/components/HOC/page-class-identifier/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/packages/storefront/frontend/components/ui/skip-link.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/storefront/frontend/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/storefront/frontend/node_modules/react-loading-skeleton/dist/skeleton.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/storefront/frontend/styles/app.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/packages/storefront/frontend/node_modules/next/font/google/target.css?{\"path\":\"fonts/index.ts\",\"import\":\"Montserrat\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-montserrat\",\"display\":\"swap\",\"weight\":[\"300\",\"400\",\"500\",\"600\",\"700\"]}],\"variableName\":\"montserrat\"}");
